import React, { FunctionComponent } from 'react';
import { Icon } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../helpers/html.utils';
import { ILabel } from '../../../models/common/label.model';
import styles from './punchout-info-component.module.scss';

type PunchoutInfoProps = {
  labels?: ILabel[] | null;
  isRestricted: boolean;
};

export const PunchoutInfo: FunctionComponent<PunchoutInfoProps> = (props: PunchoutInfoProps) => {
  return (
    <div className={`${styles['punchout-info-container']} ${props.isRestricted ? styles.restricted : styles.barred}`}>
      <div className={styles.title}>
        <Icon name='warning' />
        <p>{getLabel(props.labels, props.isRestricted ? 'punchout_restricted_product' : 'punchout_barred_product')}</p>
      </div>
      <div
        className={styles.desc}
        dangerouslySetInnerHTML={{
          __html: getLabel(props.labels, props.isRestricted ? 'punchout_restricted_info' : 'punchout_barred_info'),
        }}></div>
    </div>
  );
};

export default PunchoutInfo;
